import domReady from 'Carbon.Frontend/Resources/Private/Assets/Scripts/domReady';
import endWith from 'Carbon.Frontend/Resources/Private/Assets/Scripts/endWith';
// import A11yDialog from 'Carbon.Dialog/Resources/Private/Assets/_A11yDialog';

let dialog = [];

domReady(() => {
    let elements = document.querySelectorAll('.carbon-dialog');

    // for (let index = 0; index < elements.length; index++) {
    //     dialog.push(new A11yDialog(elements[index]));
    // }

    let offer = document.getElementById('offer');
    let form = document.forms.offerForm;
    if (offer && form) {
        let data = offer.dataset;
        ['title', 'nights', 'date'].forEach((name) => {
            if (data[name]) {
                form.elements.namedItem(`offerForm-${name}`).value = data[name];
            }
        });
        setTimeout(() => {
            if (endWith(location.href, '#') && dialog[0]) {
                dialog[0].show();
            }
        }, 10);
    }
});
